export const FieldGroupEnum = {
  OVERVIEW: 'OVERVIEW',
  COURSE_DETAILS: 'COURSE_DETAILS',
  KIT_LIST: 'KIT_LIST',
  RACEDAY_LOGISTICS: 'RACEDAY_LOGISTICS',
  REGISTRATION_INFO: 'REGISTRATION_INFO',
  SPECTATORS: 'SPECTATORS',
  HOW_TO_GET_THERE: 'HOW_TO_GET_THERE',
  VOLUNTEERS: 'VOLUNTEERS',
  RACE_OVERVIEW: 'RACE_OVERVIEW',
  ORGANISER: 'ORGANISER',
  OTHER: 'OTHER',
  ALL: 'ALL',
};

export const FieldEnum = {
  TITLE: 'TITLE',
  START_DATE: 'START_DATE',
  LOCATION: 'LOCATION',
  WEBSITE: 'WEBSITE',
  DESCRIPTION: 'DESCRIPTION',
  COURSE_DETAILS: 'COURSE_DETAILS',
  KIT_LIST: 'KIT_LIST',
  RACEDAY_LOGISTICS: 'RACEDAY_LOGISTICS',
  REGISTRATION_INFO: 'REGISTRATION_INFO',
  SPECTATORS: 'SPECTATORS',
  TRAVEL: 'TRAVEL',
  VOLUNTEERS: 'VOLUNTEERS',
  RACE_TITLE: 'RACE_TITLE',
  RACE_DISTANCE: 'RACE_DISTANCE',
  RACE_START_TIME: 'RACE_START_TIME',
  ORGANISER_TITLE: 'ORGANISER_TITLE',
  ORGANISER_DESCRIPTION: 'ORGANISER_DESCRIPTION',
  ORGANISER_WEBSITE: 'ORGANISER_WEBSITE',
  OTHER: 'OTHER',
};
